// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__2qYCG","compact":"styles_compact__3LHK2"};